import { slugs } from '@/constants/slugs'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { useTranslate } from '@/utils/translate/translate-client'

export function useGuildImpactStories(): ProjectImpact[] {
  const { t } = useTranslate('guild')

  return [
    {
      slug: slugs.soundOfFreedom,
      title: t('fightingForJustice', 'Fighting for justice and protecting vulnerable children.'),
      description: t(
        'firstStepRaisingAwarenessTowardChange',
        'Raising awareness is the first step toward change. Sound of Freedom is dedicated to exposing the harsh realities of child trafficking and igniting global action. Discover how this powerful film is mobilizing people worldwide to stand up for the most vulnerable and drive meaningful change. ',
      ),
      logoUrl: getCloudinaryImageUrl({
        path: '/v1684270092/angel-app/sound-of-freedom/discovery_images/SOF-light.svg',
        transforms: 'q_auto,e_trim',
      }),
      backgroundUrl: getCloudinaryImageUrl({
        path: '/v1722524406/angel-studios/guild/impact/Property_1_Background-Image-SOF.webp',
        transforms: 'q_auto,c_scale,w_1736,dpr_auto',
      }),
      trailerUrl: 'https://www.youtube-nocookie.com/embed/UwSBQWI-bek',
      stories: [
        {
          author: 'Tony Robbins',
          description: t('togetherWeCanEndThis', 'Together we can end this! We can put an end to child trafficking'),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1722957496/angel-studios/guild/impact/Stories/Screenshot_2024-08-06_at_8.15.36_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://video.wixstatic.com/video/7591d6_5c19877492fc4d64abd2d27438ac5da9/720p/mp4/file.mp4',
        },
        {
          author: 'Jewel',
          description: t('itIsSoTouching', `It is so touching, you're going to love it`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1722957457/angel-studios/guild/impact/Stories/Screenshot_2024-08-06_at_8.22.59_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://video.wixstatic.com/video/7591d6_912c92e3b71341638446b44e28c5accf/720p/mp4/file.mp4',
        },
        {
          author: 'Mel Gibson',
          description: t('firstStepAwareness', 'The first step in eradicating this crime is awareness'),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1722957406/angel-studios/guild/impact/Stories/Screenshot_2024-08-06_at_8.25.12_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://video.wixstatic.com/video/7591d6_5d22247d58b044a087b60f5df8853331/720p/mp4/file.mp4',
        },
        {
          author: 'Luis Fonsi',
          description: t(
            'needCreateAwareness',
            `We need to create awareness. We need to use our voices. It's the most powerful film I've ever seen`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1722957182/angel-studios/guild/impact/Stories/Screenshot_2024-08-06_at_8.34.18_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://video.wixstatic.com/video/7591d6_6d689d99b1ab4451862a85f2c619bbb4/720p/mp4/file.mp4',
        },
        {
          author: 'Lauren Daigle',
          description: t(
            'seeSomethingChangeChildren',
            'It is my hope and my prayer that we see something change in this world in regards to these children',
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1722955250/angel-studios/guild/impact/Stories/Screenshot_2024-08-06_at_8.40.15_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://video.wixstatic.com/video/17280e_ffb46199370b4b75a714c3b6247e6a88/720p/mp4/file.mp4',
        },
      ],
    },
    {
      slug: slugs.wingfeatherSaga,
      title: t('fuelingImaginationInspiringCourage', 'Fueling imagination and inspiring courage.'),
      description: t(
        'fearlessFamilyOvercomesObstacles',
        `The Wingfeather Saga is a thrilling fantasy series about a fearless family who overcomes endless obstacles to fulfill their destiny. This epic tale is inspiring kids and families alike to bond together to face any challenge that comes their way. Discover how The Wingfeather Saga is encouraging kids to be brave and bold.`,
      ),
      logoUrl: getCloudinaryImageUrl({
        path: '/v1723562313/angel-studios/guild/impact/The_Wingfeather_Saga.webp',
        transforms: 'q_auto,e_trim',
      }),
      backgroundUrl: getCloudinaryImageUrl({
        path: '/v1743796586/angel-studios/guild/impact/WFS_S2-backdrop_Horizontal-8k_TM_v02.webp',
        transforms: 'q_auto,c_scale,w_1736,dpr_auto',
      }),
      trailerUrl: 'https://www.youtube-nocookie.com/embed/l-uxplG-FXs',
      stories: [
        {
          author: 'An Angel Fan',
          description: t(
            'fanBeforeAnimator',
            `I was a fan of this series even before I became an animator for [The] Wingfeather Saga`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723562635/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_9.23.16_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/a986c4b6-d03a-4bf2-a4b8-8e474ad455d5.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t(
            'familyStillStrongTogether',
            `[The] Wingfeather Saga showed me that even in dark moments a family can still be strong together and love each other`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723562745/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_9.25.16_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/60a82a75-7faf-4534-b184-fbd84812e300.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t(
            'inspireMeToBeBrave',
            `I love seeing The Wingfeather Saga characters develop. They inspire me to be brave`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723563024/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_9.28.10_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/e4d1c243-4be7-4003-b551-91fb75d4ae98.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t(
            'thankYouWingfeatherSaga',
            `Thank you for making Wingfeather Saga and Tuttle Twins!  I recommend you watch these shows`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1724681069/angel-studios/guild/impact/Stories/Boy_Orange_Shirt_Hotwheels_Wall.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/ebcf6574-4991-43cb-966e-116fcd81afeb.m3u8',
        },
      ],
    },
    {
      slug: slugs.soundOfHopeTheStoryOfPossumTrot,
      title: t('reverseFosterCrisis', 'Helping to reverse the foster care crisis.'),
      description: t(
        'shedsLightDevastatingCircumstances',
        `Sound of Hope: The Story of Possum Trot sheds light on the devastating circumstances endured by far too many children living in the foster care system. The resolve of a Texas pastor and his wife, along with their congregation, to adopt children from difficult backgrounds is inspiring people everywhere to adopt. See how this film is helping give every child what they so richly deserve: a safe home and a loving family.`,
      ),
      logoUrl: getCloudinaryImageUrl({
        path: '/v1714755616/studio-app/catalog/e3bdc913-77eb-4039-82b3-b80432e3576a.webp',
        transforms: 'q_auto,e_trim',
      }),
      backgroundUrl: getCloudinaryImageUrl({
        path: '/v1723053154/angel-studios/guild/impact/Property_1_SOH.webp',
        transforms: 'q_auto,c_scale,w_1736,dpr_auto',
      }),
      trailerUrl: 'https://www.youtube-nocookie.com/embed/-nyh9tcGFcI',
      stories: [
        {
          author: 'Terrence K Williams',
          description: t('movieRelateTo', 'I just saw a movie that I could relate to'),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723056702/angel-studios/guild/impact/Stories/Screenshot_2024-08-07_at_12.50.44_PM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl:
            'https://content.angelstudios.com/guild/impact/Sight_AmazingGrace_RebaTrailer_NowPlaying_Subs_4x5_20240520_JH.mp4',
        },
        {
          author: 'LeToya Luckett',
          description: t('weNeedPositivity', 'With everything going on in this world, we need positivity'),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723056982/angel-studios/guild/impact/Stories/Screenshot_2024-08-07_at_12.55.42_PM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://content.angelstudios.com/guild/impact/LeToya+TODAY9x16_v2.mp4',
        },
        {
          author: 'Catherine Sutherland',
          description: t('beautifullyShotExquisitelyActed', 'I was speechless. Beautifully shot and exquisitely acted'),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723057312/angel-studios/guild/impact/Stories/Screenshot_2024-08-07_at_1.01.04_PM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://content.angelstudios.com/guild/impact/Catherine_Sutherland_9x16_62824_JB.mp4',
        },
        {
          author: 'Dad Life Jason',
          description: t('bringCoupleTissues', 'Bring a couple boxes of tissues'),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723057565/angel-studios/guild/impact/Stories/Screenshot_2024-08-07_at_1.05.16_PM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://content.angelstudios.com/guild/impact/Jason+Linton+Testimonial.mp4',
        },
      ],
    },
    {
      slug: slugs.sight,
      title: t('inspiringPerserverence', 'Inspiring perseverance against all odds.'),
      description: t(
        'profoundlyImpactedAudiences',
        `SIGHT has profoundly impacted audiences, inspiring them to believe that the impossible is possible. Dr. Ming's escape from Communism and goal to become a renowned eye surgeon in America has motivated people worldwide to never give up on their dreams. See how his journey has become a beacon of hope and resilience for everyone who watches.`,
      ),
      logoUrl: getCloudinaryImageUrl({
        path: '/v1709839633/studio-app/catalog/55b7b7a5-9abf-4ec2-b05a-84a47d639491.webp',
        transforms: 'q_auto,e_trim',
      }),
      backgroundUrl: getCloudinaryImageUrl({
        path: '/v1723053105/angel-studios/guild/impact/Property_1_SIGHT.webp',
        transforms: 'q_auto,c_scale,w_1736,dpr_auto',
      }),
      trailerUrl: 'https://www.youtube-nocookie.com/embed/gn7TlzfNdzE',
      stories: [
        {
          author: 'Dolly Parton',
          description: t('dollyPartonSings', 'Dolly Parton sings, Dr. Ming Wang plays Er Hu'),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1752257579/angel-app/Celebrity-patient-Dolly-Parton-IMG_0354-scaled.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://content.angelstudios.com/guild/impact/Dolly+Parton+sings%2C+Dr.+Ming+Wang+plays+Er+Hu.mp4',
          hideQuotes: true,
        },
        {
          author: 'Reba McEntire',
          description: t(
            'rebaIncredibleTrueStory',
            'This is an incredible true story about my friend Ming Wang who overcame unbelievable odds to become a world-class eye surgeon',
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723054309/angel-studios/guild/impact/Stories/Screenshot_2024-08-07_at_12.10.39_PM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl:
            'https://content.angelstudios.com/guild/impact/Sight_AmazingGrace_RebaTrailer_NowPlaying_Subs_4x5_20240520_JH.mp4',
        },
        {
          author: 'Steven He',
          description: t('seeAapi', `It's great to see an AAPI story represented on the big screen`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723054771/angel-studios/guild/impact/Stories/Screenshot_2024-08-07_at_12.18.42_PM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://content.angelstudios.com/guild/impact/Steven+He+Sight+Short+2+(Draft+1)+-+HD+1080p.mp4',
        },
        {
          author: 'David Henrie',
          description: t('makeImpossiblePossible', `It will make you believe that the impossible is possible`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723055127/angel-studios/guild/impact/Stories/Screenshot_2024-08-07_at_12.24.44_PM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://content.angelstudios.com/guild/impact/c0a2122b81b848fda4dcfd5c1629b41d.mp4',
        },
        {
          author: 'Dr. Youn',
          description: t('drYounLovesSightMovie', `I absolutely love this movie and I think you will too`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723055471/angel-studios/guild/impact/Stories/Screenshot_2024-08-07_at_12.30.33_PM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://content.angelstudios.com/guild/impact/Sight_Dr.Youn.mp4',
        },
      ],
    },
    {
      slug: slugs.cabrini,
      title: t('spreadingIrrepressibleCourage', 'Spreading irrepressible courage and compassion.'),
      description: t(
        'powerOfPersonNotAfraid',
        `Cabrini illustrated the power of a person who isn't afraid to stand up for what's right. Mother Cabrini's tireless efforts to transform life for the immigrant, the orphan, and anyone else on the margins of society have had a ripple effect throughout history, and more are being inspired by her story now than ever before. See how her persistent, unapologetic service and activism are leading audiences worldwide to stand up for the vulnerable.`,
      ),
      logoUrl: getCloudinaryImageUrl({
        path: '/v1702499440/studio-app/catalog/9551fb9a-cc69-4a30-a183-d0104ed9fec7.webp',
        transforms: 'q_auto,e_trim',
      }),
      backgroundUrl: getCloudinaryImageUrl({
        path: '/v1723559974/angel-studios/guild/impact/Property_1_Cabrini.webp',
        transforms: 'q_auto,c_scale,w_1736,dpr_auto',
      }),
      trailerUrl: 'https://www.youtube-nocookie.com/embed/ZaMlUazXvyY',
      stories: [
        {
          author: 'David Henrie',
          description: t(
            'reallyMovedMe',
            `[Cabrini] really moved me and I can't wait to expose my daughter to [this movie]`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723560722/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_8.51.08_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://content.angelstudios.com/guild/impact/IMG_1791.mp4',
        },
        {
          author: 'An Angel Fan',
          description: t('cabriniAmazingMovie', `Cabrini was an amazing movie. I commend her for all that she did`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723560951/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_8.54.59_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/67fee1d2-a202-44e1-95bb-5e7f1fc2b817.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t(
            'strongVivaciousWoman',
            `Cabrini was such a strong, vivacious woman. You really have to go see [Cabrini]`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723561307/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_9.01.13_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://content.angelstudios.com/guild/impact/7022e44c-387c-4062-8bcc-6f6243888281_2.mp4',
        },
        {
          author: 'An Angel Fan',
          description: t('aTrueLight', `... a true light to all of us`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723561557/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_9.05.18_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/5cfd76d7-4e22-49d0-a31c-85fc6f05fa1e.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t('weCanMoveMountains', `Like Cabrini—with faith, hope, and courage—we can move mountains`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723561662/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_9.07.12_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/c6e2f7d0-8f51-4ae5-98fb-f5b7d4268be1.m3u8',
        },
      ],
    },
    {
      slug: slugs.tuttleTwins,
      title: t('empoweringKidsChampions', 'Empowering kids to become champions of freedom.'),
      description: t(
        'inspiringMindsAppreciateValues',
        `Tuttle Twins is inspiring young minds to appreciate and uphold the values of freedom. Through entertaining stories and relatable characters, children learn the importance of liberty, personal responsibility, and the power of free thought. Discover how this series is shaping the next generation of independent thinkers.`,
      ),
      logoUrl: getCloudinaryImageUrl({
        path: '/v1723564831/angel-studios/guild/impact/tuttle-twins-white2.webp',
        transforms: 'q_auto,e_trim',
      }),
      backgroundUrl: getCloudinaryImageUrl({
        path: '/v1723564773/angel-studios/guild/impact/Property_1_Tuttle_Twins.webp',
        transforms: 'q_auto,c_scale,w_1736,dpr_auto',
      }),
      trailerUrl: 'https://www.youtube-nocookie.com/embed/PpvpREdzluI',
      stories: [
        {
          author: 'An Angel Fan',
          description: t('showSoFunny', `This show is so funny, I want everyone to watch it`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723565188/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.05.52_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/c154ad40-a856-4e5e-9342-e7861e921f9d.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t('everyCharacterLaugh', `Every character in this show makes me laugh`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723565379/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.09.09_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/ecf3dd4e-3aab-4bfa-8775-e170524f3699.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t(
            'workHardProtectThingsICreate',
            `Tuttle Twins taught me to work hard and protect the things I create`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723565549/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.12.01_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/a0af8e10-9f6f-45e5-b33d-560b49a7186d.m3u8',
        },
      ],
    },
    {
      slug: slugs.youngDavid,
      title: t('teachingLiveByFaith', 'Teaching the next generation to live by faith.'),
      description: t(
        'howToFulfillGodGivenMission',
        `Young DAVID is building up a generation of children who know who they are. David's adventures teach him how to fulfill his God-given mission, helping him become the spiritual giant and leader that Israel would one day desperately need. See how today's kids are learning the best lessons and values from this biblical future prophet.`,
      ),
      logoUrl: getCloudinaryImageUrl({
        path: '/v1723565758/angel-studios/guild/impact/Young_David.webp',
        transforms: 'q_auto,e_trim',
      }),
      backgroundUrl: getCloudinaryImageUrl({
        path: '/v1723565627/angel-studios/guild/impact/Property_1_Young_David.webp',
        transforms: 'q_auto,c_scale,w_1736,dpr_auto',
      }),
      trailerUrl: 'https://www.youtube-nocookie.com/embed/BAkqPt4S1hE',
      stories: [
        {
          author: 'An Angel Fan',
          description: t('bibleComeToLife', `I loved seeing the Bible come to life through beautiful animation`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723565898/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.17.26_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/040a0e24-68c6-49e9-a707-742a39fbeb9b.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t('nephewWatchShabbat', `Thank you! I'm so grateful nephew can watch this on Shabbat`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723566000/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.19.29_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/6a4eb456-8d86-4a37-8115-6dea3a42ffdf.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t(
            'inspiringAccurateDepiction',
            `Such an inspiring and accurate depiction of David it inspired me to donate`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723566097/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.21.03_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/90961b22-3d21-4f2d-b8bf-6876d1ab4cdf.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t('watchingWithSister', `I love watching each episode with my baby sister`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723566308/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.24.34_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/e4ffd675-e1f7-4176-be89-e8eae6488c58.m3u8',
        },
      ],
    },
    {
      slug: slugs.hisOnlySon,
      title: t('betterThingsToCome', 'Strengthening faith in better things to come.'),
      description: t(
        'enhancingFaithWorldwide',
        `His Only Son is enriching the faith of viewers worldwide. A fresh and harrowing take on the story of Abraham and Isaac, this film uses compelling imagery and storytelling to breathe new life into one of scripture's most conflicting, complex, and powerful stories. See how His Only Son is lifting believers and strengthening their trust in God's promises.`,
      ),
      logoUrl: getCloudinaryImageUrl({
        path: '/v1723566445/angel-studios/guild/impact/His_Only_Son.webp',
        transforms: 'q_auto,e_trim',
      }),
      backgroundUrl: getCloudinaryImageUrl({
        path: '/v1723566454/angel-studios/guild/impact/Property_1_HOS.webp',
        transforms: 'q_auto,c_scale,w_1736,dpr_auto',
      }),
      trailerUrl: 'https://www.youtube-nocookie.com/embed/F5HEpNSGmNI',
      stories: [
        {
          author: 'An Angel Fan',
          description: t('wishSpreadToEveryone', `Very inspirational. I wish it could be spread to everyone`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723566640/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.30.06_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/f269d346-0186-4ce6-ac81-7cd9eb37298a.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t('realPeopleRealThings', `Real people went through real things`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723566756/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.32.03_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/d618dfff-42af-4175-b0e1-50beef90f444.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t(
            'wordOfGodMoreUnderstandable',
            `The word of God is more understandable and relatable to our own lives`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723566990/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.35.59_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/97f6833b-7eba-4b10-a048-b1d870a9cf57.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t('recommendToAnybody', `I recommend this movie to anybody`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723567084/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.37.33_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/8427d7d1-06cc-498c-a2a9-d5f23f533987.m3u8',
        },
      ],
    },
    {
      slug: slugs.afterDeath,
      title: t('ignitingFlameHopeLifeToCome', 'Igniting a flame of hope in a life to come.'),
      description: t(
        'restoringFaithBleakWorld',
        `After Death is restoring the faith of a bleak world. A collection of powerful accounts of the world beyond, the film's overwhelming message is one of hope. See how After Death is filling grieving hearts with peace. `,
      ),
      logoUrl: getCloudinaryImageUrl({
        path: '/v1693596824/studio-app/catalog/7ef9fae2-328b-430c-84b5-1686cb65f216.webp',
        transforms: 'q_auto,e_trim',
      }),
      backgroundUrl: getCloudinaryImageUrl({
        path: '/v1723567882/angel-studios/guild/impact/Property_1_After_Death.webp',
        transforms: 'q_auto,c_scale,w_1736,dpr_auto',
      }),
      trailerUrl: 'https://www.youtube-nocookie.com/embed/wMMAnO67RPw',
      stories: [
        {
          author: 'An Angel Fan',
          description: t(
            'thankGodPeopleDoThisWork',
            `Thank God there's people in this world that do this kind of work`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723568080/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.54.03_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/f9cc214d-61a3-4568-bda7-f0d13ebeddd5.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t(
            'bridgeGapLifeDeath',
            `This movie helped me to understand and bridge the gap between life and death`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723568198/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.56.04_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/9916a4c1-3942-48a3-9950-7d53964572f2.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t(
            'answerQuestionsHeavenHell',
            `If you have any question as to if there is a heaven or hell or life after death, this movie will answer those questions`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723568333/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_10.58.26_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/de1d778e-21db-445e-8f7d-9a68ade45b0e.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t('thankYouAfterDeath', `It's amazing, thank you for [After Death]`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723568915/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_11.07.59_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/182ba773-2692-4260-b77d-4d80158177c9.m3u8',
        },
        {
          author: 'Anjelah Johnson',
          description: t('lessAfraidOfDeath', `This movie made me feel less afraid of death...it feels hopeful`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723569155/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_11.10.12_AM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl:
            'https://s3.amazonaws.com/content.angelstudios.com/guild/impact/AD_AD_AnjelahJohnson_4x5_V1_H264_20231026_CB.mp4',
        },
      ],
    },
    {
      slug: slugs.theShift,
      title: t('findingHopeAllSeemsLost', 'Finding hope when all seems lost.'),
      description: t(
        'holdOntoFaithLostEverything',
        `The Shift is inspiring audiences to hold onto faith even when they've lost everything. In the film, Kevin faces impossible choices as he fights to return to the world he knows and the woman he loves. His journey through darkness is inspiring viewers to find light in their toughest times. Discover why fans can't stop watching this powerful film.`,
      ),
      logoUrl: getCloudinaryImageUrl({
        path: '/v1723576291/angel-studios/guild/impact/The_Shift.webp',
        transforms: 'q_auto,e_trim',
      }),
      backgroundUrl: getCloudinaryImageUrl({
        path: '/v1723575994/angel-studios/guild/impact/Property_1_Shift.webp',
        transforms: 'q_auto,c_scale,w_1736,dpr_auto',
      }),
      trailerUrl: 'https://www.youtube-nocookie.com/embed/0jho0ThcyyM',
      stories: [
        {
          author: 'An Angel Fan',
          description: t(
            'broughtLightToWorldDark',
            `Angel [Studios] has brought light to a world that was dark for so long`,
          ),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723576725/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_1.18.01_PM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/eab5a89d-4390-4e3f-8733-c21c0cb658a8.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t('sawTodaySeeingTomorrow', `I saw The Shift today, and I'm going to see it tomorrow`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723577051/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_1.23.21_PM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/35e9699b-8931-41b9-9064-d7929c9f870c.m3u8',
        },
        {
          author: 'An Angel Fan',
          description: t('worldNeedsToHearThisStory', `The world needs to hear this story`),
          imageUrl: getCloudinaryImageUrl({
            path: '/v1723577155/angel-studios/guild/impact/Stories/Screenshot_2024-08-13_at_1.25.23_PM.webp',
            transforms: 'q_auto,c_scale,w_208,dpr_auto',
          }),
          videoUrl: 'https://media.angelstudios.com/copied-content/masters/b3d162e7-17ec-4dfc-87ff-ef482033db8d.m3u8',
        },
      ],
    },
  ]
}

export interface ProjectImpact {
  slug: string
  title: string
  description: string
  logoUrl: string
  backgroundUrl: string
  trailerUrl: string
  stories: WatchFreeCard[]
  isGuildMember?: boolean
}

export interface WatchFreeCard {
  author: string
  description: string
  imageUrl: string
  videoUrl: string
  hideQuotes?: boolean
}
